// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Array, ArrayT, verifyArray } from "./array";
import { AttributeId } from "./attribute-id";
import { Bool, BoolT, verifyBool } from "./bool";
import { Byte, ByteT, verifyByte } from "./byte";
import { ByteString, ByteStringT, verifyByteString } from "./byte-string";
import { Data, unionToData, unionListToData } from "./data";
import { DateTime, DateTimeT, verifyDateTime } from "./date-time";
import { Double, DoubleT, verifyDouble } from "./double";
import {
  ExpandedNodeIdValue,
  ExpandedNodeIdValueT,
  verifyExpandedNodeIdValue,
} from "./expanded-node-id-value";
import { Float, FloatT, verifyFloat } from "./float";
import { Guid, GuidT, verifyGuid } from "./guid";
import { I16, I16T, verifyI16 } from "./i16";
import { I32, I32T, verifyI32 } from "./i32";
import { I64, I64T, verifyI64 } from "./i64";
import { LocalizedText, LocalizedTextT, verifyLocalizedText } from "./localized-text";
import { NodeId, NodeIdT, verifyNodeId } from "./node-id";
import { NodeIdValue, NodeIdValueT, verifyNodeIdValue } from "./node-id-value";
import {
  QualifiedNameValue,
  QualifiedNameValueT,
  verifyQualifiedNameValue,
} from "./qualified-name-value";
import { SByte, SByteT, verifySByte } from "./sbyte";
import { StatusCodeValue, StatusCodeValueT, verifyStatusCodeValue } from "./status-code-value";
import { String, StringT, verifyString } from "./string";
import { U16, U16T, verifyU16 } from "./u16";
import { U32, U32T, verifyU32 } from "./u32";
import { U64, U64T, verifyU64 } from "./u64";
import { XmlElement, XmlElementT, verifyXmlElement } from "./xml-element";

/**
 * A NodeId paired with a concrete value, optionally on a non-Value attribute.
 */
export class NodeValue implements flatbuffers.IUnpackableObject<NodeValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NodeValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNodeValue(bb: flatbuffers.ByteBuffer, obj?: NodeValue): NodeValue {
    return (obj || new NodeValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNodeValue(bb: flatbuffers.ByteBuffer, obj?: NodeValue): NodeValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NodeValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  nodeId(obj?: NodeId): NodeId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  valueType(): Data {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Data.NONE;
  }

  value<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  attributeId(): AttributeId {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : AttributeId.Value;
  }

  static startNodeValue(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addNodeId(builder: flatbuffers.Builder, nodeIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nodeIdOffset, 0);
  }

  static addValueType(builder: flatbuffers.Builder, valueType: Data) {
    builder.addFieldInt8(1, valueType, Data.NONE);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, valueOffset, 0);
  }

  static addAttributeId(builder: flatbuffers.Builder, attributeId: AttributeId) {
    builder.addFieldInt32(3, attributeId, AttributeId.Value);
  }

  static endNodeValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // node_id
    builder.requiredField(offset, 8); // value
    return offset;
  }

  static createNodeValue(
    builder: flatbuffers.Builder,
    nodeIdOffset: flatbuffers.Offset,
    valueType: Data,
    valueOffset: flatbuffers.Offset,
    attributeId: AttributeId,
  ): flatbuffers.Offset {
    NodeValue.startNodeValue(builder);
    NodeValue.addNodeId(builder, nodeIdOffset);
    NodeValue.addValueType(builder, valueType);
    NodeValue.addValue(builder, valueOffset);
    NodeValue.addAttributeId(builder, attributeId);
    return NodeValue.endNodeValue(builder);
  }

  unpack(): NodeValueT {
    return new NodeValueT(
      this.nodeId() !== null ? this.nodeId()!.unpack() : null,
      this.valueType(),
      (() => {
        const temp = unionToData(this.valueType(), this.value.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.attributeId(),
    );
  }

  unpackTo(_o: NodeValueT): void {
    _o.nodeId = this.nodeId() !== null ? this.nodeId()!.unpack() : null;
    _o.valueType = this.valueType();
    _o.value = (() => {
      const temp = unionToData(this.valueType(), this.value.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.attributeId = this.attributeId();
  }

  unpackFields(...fields: string[]): NodeValueT {
    const t = new NodeValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("node_id")) {
      t.nodeId = this.nodeId() !== null ? this.nodeId()!.unpack() : null;
    }
    if (fieldSet.has("value_type")) {
      t.valueType = this.valueType();
    }
    if (fieldSet.has("value")) {
      t.value = (() => {
        const temp = unionToData(this.valueType(), this.value.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("attribute_id")) {
      t.attributeId = this.attributeId();
    }
    return t;
  }
}

export class NodeValueT implements flatbuffers.IGeneratedObject {
  constructor(
    public nodeId: NodeIdT | null = null,
    public valueType: Data = Data.NONE,
    public value:
      | ArrayT
      | BoolT
      | ByteStringT
      | ByteT
      | DateTimeT
      | DoubleT
      | ExpandedNodeIdValueT
      | FloatT
      | GuidT
      | I16T
      | I32T
      | I64T
      | LocalizedTextT
      | NodeIdValueT
      | QualifiedNameValueT
      | SByteT
      | StatusCodeValueT
      | StringT
      | U16T
      | U32T
      | U64T
      | XmlElementT
      | null = null,
    public attributeId: AttributeId = AttributeId.Value,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.nodeId === null || this.nodeId === undefined) {
      throw new Error('Required field "node_id" is not set');
    }
    if (this.value === null || this.value === undefined) {
      throw new Error('Required field "value" is not set');
    }
    const nodeId = this.nodeId !== null ? this.nodeId!.pack(builder) : 0;
    const value = builder.createObjectOffset(this.value);

    return NodeValue.createNodeValue(builder, nodeId, this.valueType, value, this.attributeId);
  }

  clone(): NodeValueT {
    const obj = new NodeValueT();
    obj.nodeId = this.nodeId !== null ? this.nodeId!.clone() : null;
    obj.valueType = this.valueType;
    obj.value =
      this.value !== null && typeof (this.value as any).clone === "function"
        ? (this.value as any).clone()
        : this.value;
    obj.attributeId = this.attributeId;
    return obj;
  }

  equals(other: NodeValueT): boolean {
    if (this.nodeId !== null && other.nodeId !== null) {
      if (!this.nodeId!.equals(other.nodeId!)) return false;
    } else if (this.nodeId !== other.nodeId) return false;
    if (this.valueType !== other.valueType) return false;
    if (this.value !== null && other.value !== null) {
      if (typeof (this.value as any).equals === "function") {
        if (!(this.value as any).equals(other.value)) return false;
      } else if (this.value !== other.value) return false;
    } else if (this.value !== other.value) return false;
    if (this.attributeId !== other.attributeId) return false;
    return true;
  }
}

export function verifyNodeValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeId(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "node_id");
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkUnionConsistency(tablePos, 6, 8, "value");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 6);
        switch (uType) {
          case 1: // Bool
            {
              const o = verifier.readInt32(pos);
              verifyBool(verifier, pos + o);
            }
            break;
          case 2: // SByte
            {
              const o = verifier.readInt32(pos);
              verifySByte(verifier, pos + o);
            }
            break;
          case 3: // Byte
            {
              const o = verifier.readInt32(pos);
              verifyByte(verifier, pos + o);
            }
            break;
          case 4: // U16
            {
              const o = verifier.readInt32(pos);
              verifyU16(verifier, pos + o);
            }
            break;
          case 5: // I16
            {
              const o = verifier.readInt32(pos);
              verifyI16(verifier, pos + o);
            }
            break;
          case 6: // U32
            {
              const o = verifier.readInt32(pos);
              verifyU32(verifier, pos + o);
            }
            break;
          case 7: // I32
            {
              const o = verifier.readInt32(pos);
              verifyI32(verifier, pos + o);
            }
            break;
          case 8: // U64
            {
              const o = verifier.readInt32(pos);
              verifyU64(verifier, pos + o);
            }
            break;
          case 9: // I64
            {
              const o = verifier.readInt32(pos);
              verifyI64(verifier, pos + o);
            }
            break;
          case 10: // Float
            {
              const o = verifier.readInt32(pos);
              verifyFloat(verifier, pos + o);
            }
            break;
          case 11: // Double
            {
              const o = verifier.readInt32(pos);
              verifyDouble(verifier, pos + o);
            }
            break;
          case 12: // String
            {
              const o = verifier.readInt32(pos);
              verifyString(verifier, pos + o);
            }
            break;
          case 13: // DateTime
            {
              const o = verifier.readInt32(pos);
              verifyDateTime(verifier, pos + o);
            }
            break;
          case 14: // Guid
            {
              const o = verifier.readInt32(pos);
              verifyGuid(verifier, pos + o);
            }
            break;
          case 15: // ByteString
            {
              const o = verifier.readInt32(pos);
              verifyByteString(verifier, pos + o);
            }
            break;
          case 16: // StatusCodeValue
            {
              const o = verifier.readInt32(pos);
              verifyStatusCodeValue(verifier, pos + o);
            }
            break;
          case 17: // LocalizedText
            {
              const o = verifier.readInt32(pos);
              verifyLocalizedText(verifier, pos + o);
            }
            break;
          case 18: // QualifiedNameValue
            {
              const o = verifier.readInt32(pos);
              verifyQualifiedNameValue(verifier, pos + o);
            }
            break;
          case 19: // NodeIdValue
            {
              const o = verifier.readInt32(pos);
              verifyNodeIdValue(verifier, pos + o);
            }
            break;
          case 20: // ExpandedNodeIdValue
            {
              const o = verifier.readInt32(pos);
              verifyExpandedNodeIdValue(verifier, pos + o);
            }
            break;
          case 21: // XmlElement
            {
              const o = verifier.readInt32(pos);
              verifyXmlElement(verifier, pos + o);
            }
            break;
          case 22: // Array
            {
              const o = verifier.readInt32(pos);
              verifyArray(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 8, "value");
    verifier.checkScalarField(tablePos, 10, 4);
  } finally {
    verifier.popDepth();
  }
}
